﻿export default class Maps {
	constructor() {
		this.placesService = new window.google.maps.places.PlacesService(document.createElement('div'));
		this.autocompleteService = new window.google.maps.places.AutocompleteService();
		this.results = [];
	}

	async searchAddresses(input, firstObject = null, additionalData = null, country = null) {
		let placePredictionsReqObj = {
			input: input,
			types: ['address'],
			fields: ['name', 'place_id'],
			componentRestrictions: { country: country ? country : 'us' },
		};

		console.log('additionalData', additionalData);

		//ADDITIONAL DATA TO GIVE PRIORITY TO SOME LAT/LNG LOCATION
		if (additionalData && additionalData.lat && additionalData.lng) {
			placePredictionsReqObj.location = new window.google.maps.LatLng(additionalData.lat, additionalData.lng);
			placePredictionsReqObj.radius = 1;
		}

		await this.autocompleteService.getPlacePredictions(placePredictionsReqObj, response => {
			console.log('autocompleteService response', response);
			if (response) {
				this.results = response;
				if (firstObject) this.results.push(firstObject); // lets always add the "Not Listed" option to the results
			} else {
				if (firstObject) {
					this.results = [firstObject];
				} else {
					this.results = [];
				}
			}
		});
	}

	async getAddressDetails(suggestionResult, callback) {
		let detailsRequest = {
			placeId: suggestionResult.place_id,
			fields: ['address_components'],
		};

		await this.placesService.getDetails(detailsRequest, details => {
			console.log('maps getAddressDetails', details);

			let finalDetails = {
				address1: null,
				address2: null,
				city: null,
				state: null,
				zip: null,
				county: null,
			};

			if (details && details.address_components) {
				let addrInfo = details.address_components;
				let parsedDetails = {
					streetNumber: addrInfo.find(i => i.types.includes('street_number')),
					streetAddress: addrInfo.find(i => i.types.includes('street_address')),
					room: addrInfo.find(i => i.types.includes('room')),
					locality: addrInfo.find(i => i.types.includes('locality')),
					sublocality: addrInfo.find(i => i.types.includes('sublocality')),
					route: addrInfo.find(i => i.types.includes('route')),
					state: addrInfo.find(i => i.types.includes('administrative_area_level_1')),
					county: addrInfo.find(i => i.types.includes('administrative_area_level_2')),
					administrative_area_level_3: addrInfo.find(i => i.types.includes('administrative_area_level_3')),
					administrative_area_level_4: addrInfo.find(i => i.types.includes('administrative_area_level_4')),
					administrative_area_level_5: addrInfo.find(i => i.types.includes('administrative_area_level_5')),
					administrative_area_level_6: addrInfo.find(i => i.types.includes('administrative_area_level_6')),
					administrative_area_level_7: addrInfo.find(i => i.types.includes('administrative_area_level_7')),
					zip: addrInfo.find(i => i.types.includes('postal_code')),
				};

				//ADDRESS1
				if (parsedDetails.streetAddress) {
					finalDetails.address1 = parsedDetails.streetAddress.short_name ?? parsedDetails.streetAddress.long_name;
				} else if (parsedDetails.streetNumber && parsedDetails.route) {
					finalDetails.address1 = `${parsedDetails.streetNumber.short_name} ${parsedDetails.route.short_name}`;
				} else if (parsedDetails.route) {
					finalDetails.address1 = parsedDetails.route.short_name;
				}

				//ADDRESS2
				if (parsedDetails.room) {
					finalDetails.address2 = parsedDetails.room.long_name;
				}

				//CITY
				if (parsedDetails.locality) {
					finalDetails.city = parsedDetails.locality.long_name;
				} else if (parsedDetails.sublocality) {
					finalDetails.city = parsedDetails.sublocality.long_name;
				} else if (parsedDetails.administrative_area_level_3) {
					finalDetails.city = parsedDetails.administrative_area_level_3.long_name;
				} else if (parsedDetails.administrative_area_level_4) {
					finalDetails.city = parsedDetails.administrative_area_level_4.long_name;
				} else if (parsedDetails.administrative_area_level_5) {
					finalDetails.city = parsedDetails.administrative_area_level_5.long_name;
				} else if (parsedDetails.administrative_area_level_6) {
					finalDetails.city = parsedDetails.administrative_area_level_6.long_name;
				} else if (parsedDetails.administrative_area_level_7) {
					finalDetails.city = parsedDetails.administrative_area_level_7.long_name;
				}

				//STATE
				if (parsedDetails.state) {
					finalDetails.state = parsedDetails.state.short_name;
				}

				//ZIP
				if (parsedDetails.zip) {
					finalDetails.zip = parsedDetails.zip.short_name;
				}

				//COUNTY
				if (parsedDetails.county) {
					finalDetails.county = parsedDetails.county.long_name;
				}
			}
			//console.log('finalDetails', finalDetails);
			callback(finalDetails);
		});
	}

	clearResults() {
		this.results = [];
	}
}
